import { Dispatch, SetStateAction } from 'react';

import { SlidingPanel, Visible, TableTabs } from 'coreOld/components';
import { useAppDispatch } from 'coreOld/hooks';
import { setSelectedRow } from 'coreOld/slices';
import { ITab } from 'coreOld/types';
import CostingTab from 'partsOld/components/CostingTab';
import CompanyPartDetailsForm from 'partsOld/components/CompanyPartDetailsForm';
import HistoryTab from 'partsOld/components/HistoryTab';
import InventoryTab from 'partsOld/components/InventoryTab';
import PartInfo from 'partsOld/components/PartInfo';
import PricingTab from 'partsOld/components/PricingTab';
import UomsTab from 'partsOld/components/UomsTab';
import { mapCompanyPartToPartInfo } from 'partsOld/mappers';
import { ICompanyPart } from 'partsOld/types';

import { RowTabs } from './constants';

interface IProps {
  selectedPart?: Partial<ICompanyPart>;
  tabs?: ITab[];
  activeTab: ITab;
  setActiveTab: Dispatch<SetStateAction<ITab>>;
  isLoading?: boolean;
  isError?: boolean;
}

const CompanyPartRowDetailsView = ({
  selectedPart,
  tabs,
  setActiveTab,
  activeTab,
  isLoading,
  isError,
}: IProps) => {
  const dispatch = useAppDispatch();

  const onClosePanel = () => dispatch(setSelectedRow(null));

  return (
    <SlidingPanel isOpen={Boolean(selectedPart)} onClosePanel={onClosePanel}>
      <PartInfo part={mapCompanyPartToPartInfo(selectedPart)} isEditable={false} />

      <TableTabs tabs={tabs} onClick={setActiveTab} activeTab={activeTab}>
        <Visible when={activeTab.title === RowTabs.DETAILS}>
          <CompanyPartDetailsForm
            onClosePanel={onClosePanel}
            part={selectedPart}
            isLoading={isLoading}
            isError={isError}
          />
        </Visible>

        <Visible when={activeTab.title === RowTabs.COSTING}>
          <CostingTab part={selectedPart} />
        </Visible>

        <Visible when={activeTab.title === RowTabs.PRICING}>
          <PricingTab part={selectedPart} />
        </Visible>

        <Visible when={activeTab.title === RowTabs.UOMS}>
          <UomsTab part={selectedPart} />
        </Visible>

        <Visible when={activeTab.title === RowTabs.INVENTORY}>
          <InventoryTab part={selectedPart} />
        </Visible>

        <Visible when={activeTab.title === RowTabs.HISTORY}>
          <HistoryTab part={selectedPart} />
        </Visible>
      </TableTabs>
    </SlidingPanel>
  );
};

export default CompanyPartRowDetailsView;
